import { create } from 'zustand';
import { dashboardAPI } from '@/api/dashboard';
import { batteriesAPI } from '@/api/batteries';
import type { DashboardStats, LowStockBattery } from '@/types';

interface DashboardState {
  stats: DashboardStats | null;
  lowStockBatteries: LowStockBattery[];
  isLoading: boolean;
  error: string | null;
  lastRefresh: Date | null;
  
  fetchStats: () => Promise<void>;
  fetchLowStock: (filter?: string) => Promise<void>;
  refresh: () => Promise<void>;
  clearError: () => void;
}

export const useDashboardStore = create<DashboardState>((set, get) => ({
  stats: null,
  lowStockBatteries: [],
  isLoading: false,
  error: null,
  lastRefresh: null,

  fetchStats: async () => {
    set({ isLoading: true, error: null });
    try {
      const response = await dashboardAPI.getStats();
      set({ 
        stats: response.data.data, 
        isLoading: false,
        lastRefresh: new Date(),
      });
    } catch (error: any) {
      set({ 
        error: error.response?.data?.error?.message || 'فشل تحميل الإحصائيات',
        isLoading: false 
      });
    }
  },

  fetchLowStock: async (filter = 'all') => {
    set({ isLoading: true, error: null });
    try {
      const response = await batteriesAPI.getLowStock(filter);
      set({ 
        lowStockBatteries: response.data.data.batteries,
        isLoading: false 
      });
    } catch (error: any) {
      set({ 
        error: error.response?.data?.error?.message || 'فشل تحميل البطاريات المنخفضة',
        isLoading: false 
      });
    }
  },

  refresh: async () => {
    await Promise.all([
      get().fetchStats(),
      get().fetchLowStock(),
    ]);
  },

  clearError: () => set({ error: null }),
}));